
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getCards() {
        const url = `${API_URL}/analytics/cards`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getYear(year = null) {
        const params = year ? `?year=${year}` : '';
        const url = `${API_URL}/analytics/year-performance${params}`;
        return axios.get(url, { headers: authHeader() });
    },
    getWorkerTasksByUser(period = 'day', date = null) {
        const params = new URLSearchParams({ period });
        if (period === 'day' && date) {
            params.append('date', date);
        }
        const url = `${API_URL}/analytics/worker-tasks-by-user?${params.toString()}`;
        return axios.get(url, { headers: authHeader() });
    },
    getUndelivered() {
        const url = `${API_URL}/analytics/undelivered`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getUnvalidate() {
        const url = `${API_URL}/analytics/unvalidated`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getProduction() {
        const url = `${API_URL}/analytics/production`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getReportProductionUser(data) {
        return axios.post(`${API_URL}/export/production-user`, data, { 
            headers: {
                ...authHeader(), 
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            responseType: 'blob', 
        });
    }    
    
};